export default "__VITE_ASSET__CcyCSidC__"